import styled, { css } from 'styled-components';
import theme from '~/styles/theme';

export const TogglesStatus = styled.div`
  .rs-toggle-checked .rs-toggle-presentation {
    background-color: ${theme.darkRed};
  }
  .rs-toggle-presentation {
    background-color: ${theme.darkGreen};
  }
`;


